import React from "react";
import type { SnackbarOrigin } from "@mui/material/Snackbar";

import { Snackbar } from "../../UI/Snackbar";
import { Alert } from "../../UI/Alert";

import { IProps } from "./types";

function getAnchorOrigin(): SnackbarOrigin {
  return {
    horizontal: "left",
    vertical: "bottom",
  };
}

const EnhancedSnackbar: React.FC<IProps> = (props) => (
  <Snackbar
    open={props.open}
    onClose={getOnClose(props)}
    anchorOrigin={getAnchorOrigin()}
    autoHideDuration={props.autoHideDuration}
  >
    <Alert sx={{ width: "100%" }} severity={props.type} action={props.action}>
      {props.message}
    </Alert>
  </Snackbar>
);

function getOnClose(props: IProps) {
  return props.action ? undefined : props.onClose;
}

export { EnhancedSnackbar };
